import {
  FETCH_PROJECTS_LOGS,
  PROJECTS_LOGS_CLEAR,
  PROJECTS_LOGS_SET_PERIOD,
  PROJECTS_LOGS_SET_FILTER,
  PROJECTS_LOGS_CHANGE_ORDER,
  FETCH_PROJECTS_LOGS_FAILED,
  FETCH_PROJECTS_LOGS_STARTED,
  PROJECTS_LOGS_PAGINATED_CHANGE_PAGE
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  logs: [],
  page: 1,
  itemsPerPage: 50,
  status: statuses.idle,
  order: 'desc',
  pages: 0,
  filter: null,
  error: [],
  period: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_PROJECTS_LOGS_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case FETCH_PROJECTS_LOGS:
      return {
        ...state,
        logs: action.payload,
        status: statuses.succeeded,
        pages: Math.ceil(action.totalCount / state.itemsPerPage),
        totalCount: action.totalCount
      };
    case FETCH_PROJECTS_LOGS_FAILED:
      return { ...state, status: statuses.failed, logs: [], error: action.error };
    case PROJECTS_LOGS_PAGINATED_CHANGE_PAGE:
      return { ...state, page: action.payload };
    case PROJECTS_LOGS_CHANGE_ORDER:
      return { ...state, order: action.payload };
    case PROJECTS_LOGS_SET_FILTER:
      return { ...state, filter: action.payload };
    case PROJECTS_LOGS_SET_PERIOD:
      return { ...state, period: action.payload };
    case PROJECTS_LOGS_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
